/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_WinnersInputs */



/**
* | output |
* | --- |
* | "Winners" |
*
* @param {Raffle_WinnersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_winners = /** @type {((inputs?: Raffle_WinnersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_WinnersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gagnants")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ganadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vencedores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vincitori")
	return /** @type {LocalizedString} */ ("Winners")
});